import React from 'react';
import PropTypes from 'prop-types';
import { Button, Spinner } from 'reactstrap';
import BaseModal from 'components/shared/BaseModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHourglassHalf, faCheckCircle, faTimesCircle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';


const ModalLoadingMotor = ({ isOpen, toggle, modalMessage, showButton, statusPending }) => {
  let icon;
  let iconColor = '#0055B8'; // Color por default, el naranjo que se usa en general

  if (modalMessage === 'Su solicitud de línea fue aceptada') {
    icon = faCheckCircle;
    iconColor='green';
  } else if (modalMessage === 'Su solicitud de línea fue rechazada') {
    icon = faTimesCircle;
  } else if (modalMessage === 'Enviando al analista.' || modalMessage === 'La solicitud del motor se está procesando.'){
    icon = faInfoCircle;
  } else if (modalMessage === 'La solicitud sigue en proceso, puede cerrar esta ventana. Llegará un correo con los resultados.') {
    icon = faHourglassHalf;
  }else if (statusPending) {
    icon = faHourglassHalf; // Se muestra solo si no hay mensajes de aceptación/rechazo
  } else {
    icon = faInfoCircle;
  }

  return (
    <BaseModal
      handleModal={toggle}
      modalOpen={isOpen}
      type="custom-modal"
      backdrop="static"
      title={null}
    >
      <div className="modal-close-container">
        <button 
          type="button" 
          className="close custom-close" 
          onClick={toggle}
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div id="inline-block-container" className="modal-check text">
        <div id="inline-block-icon" className="icon-container">
          <FontAwesomeIcon icon={icon} size="1x" color={iconColor} />
        </div>
        <div id="inline-block-message" className="check-modal-text">
          {modalMessage}
        </div>
        {!showButton && (
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <Spinner
              style={{
                width: '2rem',
                height: '2rem',
                color: iconColor,
                borderColor: iconColor,
                borderTopColor: 'transparent',
              }}
            />
          </div>
        )}
      </div>
      <div className="button-container">
        {(
          modalMessage === 'La solicitud sigue en proceso, puede cerrar esta ventana. Llegará un correo con los resultados.' ||
          modalMessage === 'Estamos procesando su solicitud. Recibirá un correo por cada resolución.'
        ) && showButton && (
          <div>
            <Button
              className="warning-accept"
              color="primary"
              onClick={() => toggle()}
            >
              Cerrar
            </Button>
          </div>
        )}
      </div>
    </BaseModal>
  );
};

ModalLoadingMotor.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  modalMessage: PropTypes.string.isRequired,
  showButton: PropTypes.bool,
  statusPending: PropTypes.bool
};


export default ModalLoadingMotor;
